<template>
  <div>
    <div class="loading1" v-if="visible" role="status" aria-busy="true">
      <img src="/static/images/duitang.gif" alt="加载中" style="width: 60px;height: 60px;">
    </div>

    <div class="w100 mb30" style="overflow: hidden;background-color: #EEEEEE;display: flex">
      <div class="w43">
        <div class="tips" id="tips">
          <span class="title">精准监控</span>
          <span class="address">{{ address }}</span>
          <span class="times" id="theClock" ref="theClock"></span>
        </div>

        <div class="map" id="map" style="width: 100%;height: 80vh;margin-bottom: 1vh;"></div>

        <div class="tips1">
          <div>
            <p class="leave"></p>
            <p>设备离线</p>
            <p class="stop"></p>
            <p>设备停止</p>
            <p class="run"></p>
            <p>设备运行</p>
            <p class="alarm"></p>
            <p>设备故障</p>
          </div>
        </div>
      </div>

      <div class="w41">
        <div class="weather">
          <iframe v-if="weatherSrc"
                  scrolling="no"
                  :src="weatherSrc"
                  frameborder="0"
                  width="80%" style="height:16vh" allowtransparency="true"></iframe>
        </div>
        <div class="devices">
          <div class="device-type">
            <div class="w60" id="details">
              <div :class="tab == 1 ? 'on' : ''" @click="changeTab(1)">分组详细</div>
              <div :class="tab == 2 ? 'on' : ''" @click="changeTab(2)">设备详细</div>
            </div>
            <div class="contents">
              <div class="group-detail" id="group-detail" v-if="tab == 1">
                <div :class="'device-title group-list ' + (groupIndex == k ? 'group-select': '')"
                     v-for="(g,k) in groups"
                     :key="g.id != null ? g.id : 'g-' + k">
                  <div class="device-name" @click="selectGroup(k,g.id)">
                    {{ g.name }}
                  </div>
                  <div class="group-right">
                    <img :src="'/static/images/location-'+(g['operation_status'] == 1 ? 'run' : 'stop') + '.png'">
                    <span>{{ g.operation_status == 1 ? '启动' : '停止' }}</span>
                    <img class="group-right-arrow"
                         src="/static/images/right-arrow.png"
                         @click="goGroup(g.id)">
                  </div>
                </div>
              </div>

              <div class="device-detail1" id="device-detail" v-if="tab == 2 && deviceInfo">
                <div class="device-title" id="device-title">
                  <div
                    :class="deviceInfo.status == 2 ? 'green-area' : (deviceInfo.status == 1 ? 'red-area' : 'alarm-area')"
                    id="bg-status"></div>
                  <div class="device-name">{{ deviceInfo.name }}</div>
                  <div class="edit" @click="editParam(deviceInfo.gid)">编辑</div>
                </div>
                <div class="serial-number1">序号：{{ deviceInfo.serial }}</div>
                <div class="device-detail">
                  <div><span>水位</span><span class="right"
                                            id="water-position">{{ deviceInfo.positionLevel }}</span>
                  </div>
                  <div><span>水压（MPa）</span><span class="right"
                                                 id="water-power">{{ deviceInfo.waterPressure }}</span>
                  </div>
                  <div><span>电流（A）</span><span class="right"
                                               id="current">{{ deviceInfo.current }}</span></div>
                  <div><span>电压（V）</span><span class="right"
                                               id="electric-power">{{ deviceInfo.power }}</span></div>
                  <div><span>机油剩余时间（H）</span><span class="right"
                                                   id="remain-time">{{ deviceInfo.oilTime }}</span>
                  </div>
                  <div><span>累计运行时间（H）</span><span class="right"
                                                   id="run-time">{{ deviceInfo.runTime }}</span></div>
                  <div><span>报警信息（条）</span><span class="right"
                                                 id="alarm-info">{{ deviceInfo.runTime != "" ? 1 : 0 }} <span
                    @click="goAlarm()" v-if="deviceInfo.runTime != ''">查看</span></span></div>
                  <div><span>执行任务（条）</span><span class="right" id="execute-task">{{ deviceInfo.taskNum }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actions">
          <ul id="actions">
            <li :class="['action-type', 'action-lock', {'action-disabled': actionPending}]"
                @click="actionAction('action-lock')">
              <img :src="'/static/images/' + (actions.lock == 1 ? 'lock' : 'unlock')+ '.png'">
              <span>{{ actions.lock == 1 ? '锁定' : '解锁' }}</span>
            </li>
            <li :class="['action-type', 'action-mode', {'action-disabled': actionPending}]"
                @click="actionAction('action-mode')">
              <img :src="'/static/images/'+(actions.mode == 2 ? 'auto' : 'hand') + '.png'">
              <span>{{ actions.mode == 2 ? '自动' : '手动' }}</span>
            </li>
            <li :class="['action-type', 'action-action', {'action-disabled': actionPending}]"
                @click="actionAction('action-action')">
              <img :src="'/static/images/'+ (actions.status == 1 ? 'pause' : 'play') + '.png'">
              <span>{{ actions.status == 1 ? '停止' : '启动' }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <el-dialog :title="'分组详情'" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
      <div>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
          <div>
            <p><span>|</span>基本信息</p>
          </div>
          <el-form-item label="分组名称" prop="name" :required="true">
            <el-input size="small" v-model="editForm.name" auto-complete="off"
                      placeholder="分组名称"></el-input>
          </el-form-item>
          <div>
            <p><span>|</span>组内设备</p>
          </div>
          <div style="display: flex;">
            <el-card style="width: 50%;height: 20vh;display: grid;overflow-y: scroll;">
              <p style="margin-top: -10px;">勾选可添加的设备</p>
              <el-checkbox-group v-model="editForm.device_id" @change="handleCheckedDevicesChange">
                <div style="display: grid;">
                  <el-checkbox v-for="d in device1" :label="d.name" :key="d.id"
                               style="padding: 5px 0px;">{{ d.name }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-card>

            <el-card style="width: 50%;height: 20vh;display: grid;overflow-y: scroll;">
              <p style="margin-top: -10px;">已添加：{{ groupSelectedDevices.length }} 台 <span
                @click="deleteAllDevices"
                style="float: right;color: #0052D9;">全部删除</span>
              </p>
              <div style="display:flex;height: 30px;" v-for="d in groupSelectedDevices">
                <p style="width: 34vw;">{{ d.name }}</p>
                <p style="width:20px;height: 20px;">
                  <el-image src="/static/images/minus-red.png"
                            style="width: 14px;height: 14px;margin-top: 3px;float: right;"
                            @click="deleteCurrentDevice(d.id)"></el-image>
                </p>
              </div>
            </el-card>
          </div>

          <div>
            <p><span>|</span>参数设定</p>
          </div>

          <el-form-item label="设定压力" prop="pressure" :required="true">
            <el-input size="small" v-model="editForm.pressure" auto-complete="off"
                      placeholder="设定压力"></el-input>
            <span style="position: absolute;right: 20px;">MPa</span>
          </el-form-item>

          <el-form-item label="间歇运行" prop="run_time" :required="true">
            <el-input size="small" v-model="editForm.run_time" auto-complete="off"
                      placeholder="间歇运行"></el-input>
          </el-form-item>

          <el-form-item label="间歇停止" prop="stop_time" :required="true">
            <el-input size="small" v-model="editForm.stop_time" auto-complete="off"
                      placeholder="间歇停止"></el-input>
          </el-form-item>

          <el-form-item label="操作模式" prop="mode" :required="true">
            <el-select v-model="editForm.mode" placeholder="请选择操作模式">
              <el-option
                v-for="item in mode"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  batchAutos,
  batchLocks,
  batchPlays,
  deleteDevices,
  groupDevice,
  groupSave,
  groupsDetail,
  groupSaveAction,
  map
} from '../../api/userMG'


export default {
  data() {
    return {
      visible: false,
      loading: false,
      showdelete: false,
      actions: {
        lock: 0,
        mode: 2,
        status: 0,
      },
      formInline: {
        gid: 0,
      },
      showMap: false,
      editForm: {
        id: '',
        name: '',
        group_id: '',
        device_id: [],
        mode: '',
        run_time: '',
      },
      deviceInfo: null,
      device1: [],
      device1_id: [],
      groupSelectedDevices: [],
      selectedDevice: [],
      rules: [],
      editFormVisible: false,
      fmenu: [],
      zoom: 22,
      groups: [],
      tab: 1,
      weatherSrc: '',
      address: '',
      groupIndex: -1,
      currentId: null,
      currentGid: null,
      mode: [
        {label: '远程&本地', value: 3},
        {label: '远程', value: 2},
        {label: '本地', value: 1},
      ],
      statusData: ["leave", "stop", "run", "alarm"],
      statusData1: ["离线", "停止", "运行", "报警"],
      map: null,
      anchor: null,
      size: null,
      origin: null,
      control: {
        scale: {},
        zoom: {
          position: 'topRight',
        },
      },
      markers: [],
      clockTimer: null,
      actionPending: false,
      bMap: null,
      actionDebounceMs: 500,
      lastActionAt: 0
    }
  },
  /**
   * 创建完毕
   */
  mounted() {
    this.getdata()
    this.showDT()
    this.clockTimer = window.setInterval(() => {
      this.showDT()
    }, 1000)

    this.visible = false
    const loadWeather = () => {
      this.weatherSrc = 'http://widget.tianqiapi.com/?style=ya&skin=sogou&color=&align=&paddingtop=&fontsize='
    }
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(loadWeather, { timeout: 3000 })
    } else {
      window.setTimeout(loadWeather, 1500)
    }
  },
  beforeDestroy() {
    if (this.clockTimer) {
      window.clearInterval(this.clockTimer)
      this.clockTimer = null
    }
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    /** 选中某台设备：右侧控制与地图标记均基于同一索引的 device + status + information */
    applyDeviceSelection(n) {
      const d = this.device[n]
      if (!d) {
        return
      }
      const info = this.information[n] || []
      this.tab = 2
      this.currentId = d.did
      this.actions = {
        lock: Number(d.is_lock) || 0,
        mode: d.operation_type != null && d.operation_type !== '' ? Number(d.operation_type) : 2,
        status: d.operation_status != null && d.operation_status !== '' ? Number(d.operation_status) : 0
      }
      this.deviceInfo = {
        status: this.status[n],
        name: d.name,
        gid: d.g_id,
        serial: d.serial,
        positionLevel: info[5],
        waterPressure: info[1],
        current: info[2],
        power: info[0],
        oilTime: info[3],
        runTime: info[4],
        taskNum: d.tnum
      }
    },
    /**
     * 当前选中的分组 id。不能用 `if (formInline.gid)`：分组 id 为 0 时会误判为未选中。
     */
    getActiveSelectedGroupId() {
      if (this.groupIndex >= 0 && this.groups && this.groups[this.groupIndex]) {
        const id = this.groups[this.groupIndex].id
        if (id != null && id !== '') {
          return id
        }
      }
      const g = this.formInline && this.formInline.gid
      if (g == null || g === '') {
        return null
      }
      if (this.groupIndex < 0 && Number(g) === 0) {
        return null
      }
      return g
    },
    /**
     * 分组（右侧「分组详细」列表）的 operation_status：仅来自接口里的分组对象，与设备地图 status[] 无关。1=启动，0=停止。
     */
    groupRowOperationStatus(row) {
      if (!row || row.operation_status == null || row.operation_status === '') {
        return 0
      }
      return Number(row.operation_status) === 1 ? 1 : 0
    },
    /** 规范化 map 返回的 groups，避免字符串等类型导致列表展示异常 */
    normalizeGroupsFromApi(list) {
      const arr = list || []
      return arr.map((g) =>
        Object.assign({}, g, {
          operation_status: this.groupRowOperationStatus(g)
        })
      )
    },
    /** 全页与分组视图统一用百度地图（index.html 已引入），避免依赖未加载的腾讯 qq.maps */
    renderSuperviseBaiduMarkers() {
      const t = this
      if (!t.data || !t.data.length) {
        return
      }
      if (typeof window.BMap === 'undefined') {
        if (t.$message) {
          t.$message.error('地图 SDK 未加载，请检查是否引入百度地图脚本')
        }
        return
      }
      if (!t.bMap) {
        t.bMap = new BMap.Map('map')
        t.bMap.enableScrollWheelZoom(true)
      }
      const map = t.bMap
      map.clearOverlays()
      map.centerAndZoom(new BMap.Point(t.data[0][1], t.data[0][0]), 20)

      const MARKERS_PER_FRAME = 12
      let markerIndex = 0
      const addBMapMarkersChunk = () => {
        const end = Math.min(markerIndex + MARKERS_PER_FRAME, t.data.length)
        for (let i = markerIndex; i < end; i++) {
          const n = i
          const item = t.data[n]
          const points = new window.BMap.Point(item[1], item[0])
          const opts = {
            width: 350,
            height: 140,
            title: t.device[n].name
          }
          const infoHtml = "<div class='device-info' style='width: 300px;line-height: 30px;font-size: 14px;'>当前设备" + t.statusData1[t.status[n]] + "状态</div>" +
            "<div class='device-info' style='width: 300px;line-height: 30px;font-size: 14px;'>经纬度:" + t.data[n][1] + ',' + t.data[n][0] + '</div>'
          const infoWindows = new BMap.InfoWindow(infoHtml, opts)
          const myIcon = new BMap.Icon('/static/images/location-' + t.statusData[t.status[n]] + '.png', new BMap.Size(43, 55), {
            offset: new BMap.Size(0, -55),
          })
          const markers = new BMap.Marker(points, { icon: myIcon })
          const label = new BMap.Label(String(n + 1), {
            position: new BMap.Point(item[1], item[0]),
            offset: new BMap.Size(-5, -20)
          })
          label.setStyle({
            backgroundColor: 'none',
            color: '#ffffff',
            border: 'none',
            fontSize: '20px'
          })
          map.addOverlay(label)
          map.addOverlay(markers)
          markers.addEventListener('click', function () {
            this.openInfoWindow(infoWindows, points)
            t.applyDeviceSelection(n)
          })
        }
        markerIndex = end
        if (markerIndex < t.data.length) {
          window.requestAnimationFrame(addBMapMarkersChunk)
        } else {
          if (t.currentId) {
            t.device.forEach((item, index) => {
              if (item.did == t.currentId) {
                if (t.deviceInfo) {
                  t.deviceInfo.status = t.status[index]
                }
                t.actions = {
                  lock: Number(item.is_lock) || 0,
                  mode: item.operation_type != null && item.operation_type !== '' ? Number(item.operation_type) : 2,
                  status: item.operation_status != null && item.operation_status !== '' ? Number(item.operation_status) : 0
                }
              }
            })
          }
          setTimeout(function () {
            t.visible = false
          }, 1800)
        }
      }
      window.requestAnimationFrame(addBMapMarkersChunk)
    },
    getdata(parameter) {
      let t = this
      t.loading = true
      t.showMap = true

      map(parameter).then(res => {
        if (res.code == 200) {
          let r = res.result || res.data
          if (!r) {
            t.visible = false
            return
          }
          const rawList = Array.isArray(r.devices) ? r.devices : (r.device || [])
          t.device = rawList.map(function (d, i) {
            let lock = d.is_lock
            if (lock == null && r.infos && r.infos[i]) {
              lock = r.infos[i][7]
            }
            return Object.assign({}, d, {
              g_id: d.g_id != null ? d.g_id : (d.group_id != null ? d.group_id : d.id),
              is_lock: lock != null ? lock : 0,
              tnum: d.tnum != null ? d.tnum : 0
            })
          })
          t.data = r.latlng || []
          t.status = r.status || []
          t.names = (Array.isArray(r.names) && r.names.length) ? r.names : rawList.map(function (d) { return d.name })
          t.information = r.infos || []
          /* 分组列表：只用接口 r.groups（分组表的 operation_status），不要用设备遥测去改 */
          t.groups = t.normalizeGroupsFromApi(r.groups)
          t.address = r.address || []

          if (!t.data.length) {
            t.visible = false
            return
          }

          t.renderSuperviseBaiduMarkers()
        }
      })
    },
    goGroup(id) {
      this.editFormVisible = true
      this.getGroupDetail(id)
    },
    editParam(gid) {
      if (gid) {
        this.goGroup(gid)
      }
    },
    selectGroup(index, id) {
      this.groupIndex = index
      this.formInline.gid = id
      this.groupDevices(id)
    },
    groupDevices(id) {
      let t = this
      groupDevice({gid: id}).then(res => {
        t.device = []
        t.data = []
        t.status = []
        t.information = []

        if (res.code == 200) {
          let r = res.result || res.data
          if (!r) {
            return
          }
          t.deviceInfo = null
          t.currentId = null
          if (r.group) {
            t.actions = {
              lock: Number(r.group.is_lock) || 0,
              mode: r.group.operation_type != null && r.group.operation_type !== '' ? Number(r.group.operation_type) : 2,
              status: r.group.operation_status != null && r.group.operation_status !== '' ? Number(r.group.operation_status) : 0
            }
          }

          const devices = r.devices || []
          t.device = devices.map(function (d, i) {
            let lock = d.is_lock
            if (lock == null && r.infos && r.infos[i]) {
              lock = r.infos[i][7]
            }
            return Object.assign({}, d, {
              g_id: d.g_id != null ? d.g_id : (d.group_id != null ? d.group_id : d.id),
              is_lock: lock != null ? lock : 0,
              tnum: d.tnum != null ? d.tnum : 0
            })
          })
          t.data = r.latlng || devices.map(function (d) { return [d.latitude, d.longitude] })
          t.status = r.status || devices.map(function () { return 1 })
          t.information = r.infos || devices.map(function () { return [0, 0, 0, 0, 0, '', '', 0] })

          if (!t.data.length) {
            return
          }

          const gidx = (t.groups || []).findIndex((g) => Number(g.id) === Number(id))
          if (gidx >= 0 && r.group) {
            t.$set(t.groups[gidx], 'operation_status', t.groupRowOperationStatus(r.group))
          }

          t.renderSuperviseBaiduMarkers()
        }
      })
    },
    changeTab(index) {
      this.tab = index
      if (index == 1) {
        this.currentId = null
      } else {
        this.formInline.gid = 0
        this.groupIndex = -1
      }
    },
    actionAction(type) {
      const now = Date.now()
      if (this.actionPending || (now - this.lastActionAt) < this.actionDebounceMs) {
        return
      }
      this.lastActionAt = now
      let types = null;
      let _t = this

      _t.visible = true
      _t.actionPending = true

      let id_arr = []
      if (_t.currentId) {
        id_arr.push(_t.currentId)
      }
      const batchGid = _t.getActiveSelectedGroupId()
      if (batchGid != null && _t.device && _t.device.length > 0) {
        _t.device.forEach((item) => {
          id_arr.push(item.did)
        })

        if (type == 'action-lock') {
          groupSaveAction({gid: batchGid, type: _t.actions.lock == 0 ? 'lock' : 'unlock'}).then(res => {
          })
        } else if (type == 'action-mode') {
          groupSaveAction({gid: batchGid, type: _t.actions.mode == 2 ? 'hand' : 'auto'}).then(res => {
          })
        } else if (type == 'action-action') {
          /* 与底部文案一致：status==1 当前运行→点的是停止→写库 stop；status==0→点启动→play */
          groupSaveAction({gid: batchGid, type: _t.actions.status == 1 ? 'stop' : 'play'}).then(res => {
          })
        }
      }
      id_arr = id_arr.join(',')
      if (!id_arr) {
        _t.visible = false
        _t.actionPending = false
        return
      }
      if (type == 'action-lock') {
        this.actions.lock = this.actions.lock == 0 ? 1 : 0
        types = this.actions.lock == 0 ? 'lock' : 'unlock'
        batchLocks({ids: id_arr, type: types}).then(res => {
          if (res.code == 200) {
            _t.getdata()
          }
        }).finally(() => {
          _t.visible = false
          _t.actionPending = false
        })
      } else if (type == 'action-mode') {
        this.actions.mode = this.actions.mode == 2 ? 1 : 2
        types = this.actions.mode == 2 ? 'hand' : 'auto'
        batchAutos({ids: id_arr, type: types}).then(res => {
        }).finally(() => {
          _t.visible = false
          _t.actionPending = false
        })
      } else if (type == 'action-action') {
        this.actions.status = this.actions.status == 0 ? 1 : 0
        types = this.actions.status == 1 ? 'play' : 'stop'
        batchPlays({ids: id_arr, type: types}).then(res => {
          if (res.code == 200) {
            _t.getdata()
          }
        }).finally(() => {
          _t.visible = false
          _t.actionPending = false
        })
      } else {
        _t.visible = false
        _t.actionPending = false
      }
    },
    closeDialog() {
      this.editFormVisible = false
      this.currentId = null
      this.editForm = {
        id: '',
        name: '',
        pressure: '',
        run_time: '',
        stop_time: '',
        mode: '',
        device_id: []
      }
    },
    getGroupDetail(id) {
      groupsDetail({id: id}).then(res => {
        if (res.code == 200) {
          this.loading = false
          this.editForm.name = res.result.group.name
          this.editForm.id = res.result.group.id
          if (res.result.params != null) {
            this.editForm.pressure = res.result.params.pressure
            this.editForm.mode = res.result.params.mode
            this.editForm.run_time = res.result.params.run_time
            this.editForm.stop_time = res.result.params.stop_time
          }
          let s_d = [];
          if (res.result.select_device.length > 0) {
            res.result.select_device.forEach(item => {
              s_d.push(item.id);
            })
            this.selectedDevice = s_d;
          }
          this.device1 = res.result.select_device
          this.groupSelectedDevices = res.result.device;
        }
      })
    },
    deleteAllDevices() {
      this.$confirm('确定要全部删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        if (this.groupSelectedDevices.length > 0) {
          this.groupSelectedDevices.forEach(item => {
            ids.push(item.id)
          })
        } else {
          return false;
        }
        deleteDevices({id: ids}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '设备已删除！'
            })
            this.getGroupDetail(this.group_id)
          } else {
            this.$message.error('设备删除失败！')
          }
        })
      })
    },
    showDT() {
      const el = this.$refs.theClock
      if (!el) {
        return
      }
      const days = ['日', '一', '二', '三', '四', '五', '六']
      const currentDT = new Date()
      const y = currentDT.getFullYear()
      const m = currentDT.getMonth() + 1
      const date = currentDT.getDate()
      const day = currentDT.getDay()
      let hs = currentDT.getHours()
      let ms = currentDT.getMinutes()
      let ss = currentDT.getSeconds()
      if (hs < 10) {
        hs = '0' + hs
      }
      if (ms < 10) {
        ms = '0' + ms
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      const sunday = '星期' + days[day]
      el.textContent = y + '年' + m + '月' + date + '日 ' + hs + ':' + ms + ':' + ss + ' ' + sunday
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          let param = {
            id: this.editForm.id,
            name: this.editForm.name,
            device_id: this.device1_id,
            pressure: this.editForm.pressure,
            run_time: this.editForm.run_time,
            stop_time: this.editForm.stop_time,
            mode: this.editForm.mode
          };
          groupSave(param)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '分组保存成功！'
                })
                this.editForm = {
                  id: '',
                  name: '',
                  pressure: '',
                  run_time: '',
                  stop_time: '',
                  mode: '',
                  device_id: []
                }
              } else {
                this.$message({
                  type: 'info',
                  message: '分组保存失败！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('分组保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    handleCheckedDevicesChange(val) {
      let selected = [];
      if (val) {
        this.device1.forEach(item => {
          val.forEach(item1 => {
            if (item1 == item.name) {
              selected.push(item.id)
            }
          })
        })
        this.device1_id = selected
      }
    },
  },
}
</script>

<style scoped>
.el-main {
  margin-top: 2vh;
}

.loading1 {
  width: 100vw;
  height: 100vh;
  color: #fff;
  font-size: 20px;
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.device-info {
  height: 25px;
}

.w100 {
  width: 100%;
}

.w43 {
  width: 70vw;
  float: left;
  padding-top: 2vh;
}

.w43 .tips {
  width: 60.9vw;
  height: 55px;
  line-height: 55px;
  background-color: #fff;
  font-size: 16px;
}

.times {
  float: right;
  margin-right: 40px;
}

.tips span:nth-child(2) {
  margin-left: 20px;
  color: rgba(0, 0, 0, 0.6);
}

.w41 {
  width: 24vw;
  height: 80vh;
  margin-left: 1vw;
  margin-right: 1vw;
  float: left;
  padding-top: 2vh;
  background-color: #EEEEEE;
}

.tips .title {
  font-size: 18px;
  margin-left: 34px;
  font-weight: bold;
}

.group-select {
  background-color: #E7E7E7;
}

.weather {
  height: 15vh;
  background-color: #fff;
}

.devices {
  height: 56.3vh;
  font-size: 16px;
  background-color: #fff;
  border-radius: 3px;
  margin-top: 1vh;
}

.device-type {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #E7E7E7;
}

.w60 div {
  width: 50%;
  line-height: 50px;
  float: left;
  text-align: center;
}

.on {
  color: #0052D9;
  border-bottom: 2px solid #0052D9 !important;
}

.w60 {
  width: 100%;
  height: 7vh;
  margin: 0 auto;
}

.contents {
  height: 45vh;
  margin-top: 1vh;
  padding: 0px 5%;
}

.serial-number1 {
  color: rgba(0, 0, 0, 0.9);
  margin-top: 5px;
  padding-bottom: 10px;
  font-size: 12px;
  border-bottom: 1px solid #E7E7E7;
}

.device-title {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  border-bottom: 1px solid #E7E7E7;
}

.device-detail div {
  line-height: 40px;
}

.device-name {
  padding-left: 10px;
  width: 50%;
  font-size: 18px;
}

.edit {
  color: #0052D9;
  position: absolute;
  right: 5%;
}

.device-detail .right {
  position: absolute;
  right: 5%;
}

.red-area {
  background-color: #ff0000;
  height: 10px;
  width: 20px;
  border-radius: 3px;
  margin-top: 2.5vh;
  margin-right: 10px;
}

.green-area {
  background-color: #0DAC78;
  height: 10px;
  width: 20px;
  border-radius: 3px;
  margin-top: 2.5vh;
  margin-right: 10px;
}

.leave-area {
  background-color: #808080;
  height: 10px;
  width: 20px;
  border-radius: 3px;
  margin-top: 2.5vh;
  margin-right: 10px;
}

.alarm-area {
  background-color: #ED7B2F;
  height: 10px;
  width: 20px;
  border-radius: 3px;
  margin-top: 2.5vh;
  margin-right: 10px;
}

.group-list img:nth-child(1) {
  width: 14px;
  height: 14px;
}

.tips1 {
  width: 61vw;
  position: absolute;
  z-index: 1000;
  margin-top: -5.3vh;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #FFFFFF 100%);
}

.tips1 div {
  width: 40vw;
  margin-left: 35vw;
}

.tips1 p {
  float: left;
  line-height: 40px;
  font-size: 14px;
}

.tips1 p:nth-child(2n+1) {
  width: 30px;
  height: 15px;
  margin-top: 12px;
  margin-right: 10px;
  border-radius: 10px;
}

.tips1 p:nth-child(2n+2) {
  width: 80px !important;
  height: 20px;
  margin-top: 0px;
}

.leave {
  background-color: #808080;
}

.stop {
  background-color: #E34D59;
}

.alarm {
  background-color: #ED7B2F;
}

.run {
  background-color: #0DAC78;
}

.actions {
  margin-top: 1.5vh;
  width: 100%;
  background-color: #fff;
  height: 12vh;
}

.actions ul {
  width: 70%;
  margin: 0 auto;
}

.actions li {
  width: 32%;
  float: left;
  height: 50px;
  font-size: 16px;
  display: grid;
  text-align: center;
  margin: 2.2vh 0.5% 0px;
}

#group-detail {
  height: 50vh;
  bottom: 2vh;
}

.device-name {
  padding-left: 10px;
  width: 50%;
  font-size: 18px;
}

.actions li img {
  margin: 0 auto;
}

.action-disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}

.group-right {
  width: 50%;
  text-align: right;
  margin-right: 10px;
}

.group-right-arrow {
  width: 10px !important;
  height: 14px !important;
}

.group-right span {
  margin: 0 10px;
}

.device-run {
  background-color: #0DAC78;
}

.device-stop {
  background-color: #E34D59;
}

.device-alarm {
  background-color: #ED7B2F;
}

.device-leave {
  background-color: #808080;
}
</style>




// WEBPACK FOOTER //
// src/views/supervise/index.vue